import React from 'react';
import TolTag from '../../shared/tol-tag';
import RelativeTime from '../relative-time';
import Bookmark from '../bookmark';
import {
  Container,
  Secondary,
  Separator,
  TopLine,
  BottomLine,
} from './styles';
import { captionProps, defaultCaptionProps } from './prop-types';

export default function Desktop({ wire }) {
  const {
    caption,
    campaign,
    timestamp,
    isSponsored,
    showBookmarkHint,
  } = wire;

  return (
    <Container>
      <TopLine>
        {!!campaign && <TolTag {...campaign} />}
      </TopLine>
      <BottomLine>
        {!!caption.url && (
          <span className="main">
            <a href={caption.url} data-event-type="click" data-event="link_click">{caption.text}</a>
          </span>
        )}
        {!!(caption.url && isSponsored) && <Separator className="separator">&bull;</Separator>}
        {!!isSponsored && (
          <Secondary>
            sponsored
          </Secondary>
        )}
        {timestamp && (
          <>
            <Separator className="separator">&bull;</Separator>
            <span className="wire__date secondary">
              <RelativeTime timestamp={timestamp} />
            </span>
          </>
        )}
        <Bookmark wire={wire} showBookmarkHint={showBookmarkHint} />
      </BottomLine>
    </Container>
  );
}

Desktop.propTypes = captionProps;
Desktop.defaultProps = defaultCaptionProps;
